import Vue from 'vue'

Vue.directive('dev', {
  inserted: function (el) {
    el.classList.add('v-dev')
    if (process.env.PROD) {
      el.style.display = 'none'
    }
  }
})
